export default __webpack_public_path__ + "static/perfectAccentProduct-a60675debb31a1690ee3383ddc843765.png";